module.exports = __webpack_public_path__ + "media/src/images/icons/funnel-fed23cc05a6aff0101ca9d7b3ce3262b.svg";